const MAX_SOCIAL_JSON_DEPTH = 3;

const normalizeSocial = social => {
  let normalizedSocial = social;

  for (let depth = 0; depth < MAX_SOCIAL_JSON_DEPTH; depth += 1) {
    if (typeof normalizedSocial !== 'string') break;
    if (normalizedSocial.trim() === '') return {};

    try {
      normalizedSocial = JSON.parse(normalizedSocial);
    } catch (_error) {
      return {};
    }
  }

  return normalizedSocial &&
    typeof normalizedSocial === 'object' &&
    !Array.isArray(normalizedSocial)
    ? normalizedSocial
    : {};
};

export default normalizeSocial;
